import { useState } from "react";

export interface ContextMenuState<T> {
  mouseX: number;
  mouseY: number;
  data: T;
}

export function useContextMenu<T>() {
  const [contextMenu, setContextMenu] = useState<ContextMenuState<T> | null>(
    null
  );

  const handleContextMenu = (event: React.MouseEvent, data: T) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
            data,
          }
        : null
    );
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };

  return { contextMenu, handleContextMenu, handleCloseContextMenu };
}
